import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import AccountCell from '@/onenetwork/components/datatable/AccountCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import AccountAPI from '@/modules/account/constants/account.api.uri.const.ts'
import { formatTableDataAccount } from '../helper/table'
import { buildFilterObject } from '@/utils/filter'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { getMembershipPlanFilter } from '@/utils/helper'
import { markRaw } from 'vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum AccountListActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface AccountListStore {
  action_type: AccountListActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Object,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useAccountListStore = defineStore('account.list', {
  state: (): AccountListStore => ({
    action_type: AccountListActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'code',
        type: 'text',
        label: 'Mã tài khoản',
        placeholder: 'Nhập mã tài khoản',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'account_type',
        type: 'select-multiple',
        label: 'Lọc theo loại tài khoản',
        placeholder: 'Chọn loại tài khoản',
        value: '',
        options: [
          { label: 'Tài khoản thường', value: 'regular' },
          { label: 'Môi giới', value: 'broker' },
        ],
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Lọc theo trạng thái',
        placeholder: 'Chọn trạng thái',
        value: '',
        options: [
          { label: 'Hoạt động', value: 'active' },
          { label: 'Ngừng hoạt động', value: 'inactive' },
          { label: 'Đã khóa', value: 'locked' },
        ],
      },
      {
        key: 'kyc_processing_status',
        type: 'select-multiple',
        label: 'Tình trạng KYC',
        placeholder: 'Chọn tình trạng KYC',
        value: '',
        options: [
          { label: 'Chưa KYC', value: 'no-kyc' },
          { label: 'Đang KYC', value: 'pending' },
          { label: 'Đã KYC', value: 'approved' },
          { label: 'Đã Từ chối', value: 'rejected' },
        ],
      },
      {
        key: 'package_id ',
        type: 'select-multiple',
        label: 'Lọc theo gói thành viên',
        placeholder: 'Chọn gói thành viên',
        value: '',
        options: getMembershipPlanFilter(),
      },
      {
        key: 'registerDate',
        type: 'date-range',
        label: 'Lọc theo ngày đăng ký',
        placeholder: 'Chọn ngày đăng ký',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách tài khoản',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        code: { label: 'CODE', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        // avatar: { label: 'Ảnh', component: markRaw(ThumbCell), visible: true, sort: false, config: {width: '40px', height: '40px', borderRadius: '4px'} },
        // phone_number: { label: 'SDT', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        account: {label: 'Thông tin', component: markRaw(AccountCell), visible: true, sort: false, config: {} },
        birthday: { label: 'Ngày sinh', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        // address: { label: 'Khu vực', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        account_type: { label: 'Loại TK', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        membership: { label: 'Gói TK', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        account_status: { label: 'Trạng thái', component: markRaw(TagCell), visible: true, sort: false, config: {} },
        cash_balance: { label: 'Tiền mặt', component: markRaw(MoneyCell), visible: true, sort: false, config: {color: '#177300'} },
        point_balance: { label: 'Điểm', component: markRaw(NumberCell), visible: true, sort: false, config: {} },
        kyc_status: { label: 'KYC', component: markRaw(TagCell), visible: true, sort: false, config: {} },
        kyc_request_date: { label: 'Ngày KYC', component: markRaw(DateTimeCell), visible: true, sort: '', config: {} },
        created_at: { label: 'Ngày đăng ký', component: markRaw(DateTimeCell), visible: true, sort: 'desc', config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách tài khoản',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.page = 1
      this.action_type = AccountListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    resetFilter () {
      this.filter = this.filter.map(item => ({...item, value: ''}))
      this.page = 1
      this.action_type = AccountListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = AccountListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = AccountListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
        this.action_type = AccountListActionTypes.FILTERING
        this.uuid = uuid.v4()
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList() {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = AccountListActionTypes.FETCHING
          const sort = this.sortFilter
          //get key and value from filter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            sort: sort
          };

          const filter = buildFilterObject(this.filter, pagination);
          const res: any = await APIClient.get(AccountAPI.account.list, {
            params: filter
          })
          const { data } = res.data
          this.data = {
            list: formatTableDataAccount(data.data) || [],
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0
          }
          this.action_type = AccountListActionTypes.FETCH_SUCCESS
          resolve(data);
        } catch (e) {
          this.action_type = AccountListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }

  }
})
